import { supabase } from '@/integrations/supabase/client';

export interface CompanyCheckResult {
  exists: boolean;
  organization?: { id: string; name: string; created_at: string };
  message?: string;
}

export async function checkCompanyNameExists(companyName: string): Promise<CompanyCheckResult> {
  try {
    if (!companyName || companyName.trim().length === 0) {
      return { exists: false };
    }

    const trimmedName = companyName.trim();
    const { data, error } = await supabase
      .from('organizations')
      .select('id, name, created_at')
      .ilike('name', trimmedName)
      .limit(1);

    if (error) throw error;

    if (data && data.length > 0) {
      return {
        exists: true,
        organization: data[0],
        message: `A company with the name "${data[0].name}" already exists in our system.`
      };
    }

    return { exists: false };
  } catch (error) {
    throw error;
  }
}
